import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_project/purchases/$projectId/$subProjectId/supplier-quote")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/supplier-quote-request/$projectId/$subProjectId/received-quotes",
      params,
    });
  },
});
